import { ICcdaDiagnosis, IDiagnosesItem } from 'entities/Diagnoses/Diagnoses.models';

export const diagnosesToDataMapper = (response: ICcdaDiagnosis[]) => {
  return response.map((item) => ({ displayName: item.displayName, code: item.code }));
};

export const getDiagnosisName = (diagnosis: IDiagnosesItem) => `[${diagnosis.code}] ${diagnosis.displayName}`;
